import type { ReactNode } from 'react'
import { Sidebar } from './Sidebar'
import { TerminalHeader } from './TerminalHeader'
import { ResizableSplitPane } from './ResizableSplitPane'

/**
 * Multi-pane institutional workspace.
 * Positions blotter spans full viewport width from the left edge.
 */
export function DesktopLayout({
  main,
  right,
  bottom,
}: {
  main: ReactNode
  right?: ReactNode
  bottom?: ReactNode
}) {
  const workspace = right ? (
    <div className="grid h-full min-h-0 grid-cols-[minmax(0,1fr)_minmax(240px,300px)] gap-px bg-terminal-border/40">
      <section className="min-h-0 bg-terminal-bg">{main}</section>
      <aside className="terminal-scroll min-h-0 overflow-y-auto bg-terminal-surface">
        {right}
      </aside>
    </div>
  ) : (
    <div className="h-full min-h-0 bg-terminal-bg">{main}</div>
  )

  const topChrome = (
    <div className="flex h-full min-h-0 w-full">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <TerminalHeader />
        <div className="min-h-0 flex-1">{workspace}</div>
      </div>
    </div>
  )

  return (
    <div className="flex h-dvh w-full overflow-hidden bg-terminal-bg text-terminal-fg">
      {bottom ? (
        <ResizableSplitPane
          className="h-full w-full"
          top={topChrome}
          bottom={
            <div className="h-full w-full min-w-0 border-t border-terminal-border/40 bg-terminal-surface">
              {bottom}
            </div>
          }
        />
      ) : (
        topChrome
      )}
    </div>
  )
}
